import cqrsApiService from './cqrsApiService.js';

export default {
  install(Vue) {
    Vue.prototype.$cqrsGet = function(url, data, config) {
      return cqrsApiService.Get(url, data, this, config);
    }

    Vue.prototype.$cqrsPost = function (url, data, config) {
      return cqrsApiService.Post(url, data, this, config);
    }

    Vue.prototype.$cqrsDelete = function (url, data, config) {
      return cqrsApiService.Delete(url, data, this, config);
    }
  }
};